import Axios from 'axios';
import Cookies from 'js-cookie';

const SETTINGS_URL = 'https://api.brandsafe.no/v1/config/config/settings';

export const PRINT_BASKET_SETTING = 'print.basket';

// One request per customer/setting per page load
const cache = {};

export function getCustomerSetting(key) {
    const customer_id = Cookies.get('bs_customer_id');
    const cache_key = customer_id + '|' + key;

    if (!cache.hasOwnProperty(cache_key)) {
        cache[cache_key] = Axios.get(SETTINGS_URL + '?customer_id=' + customer_id + '&setting=' + key, {
            headers: { 'Authorization': 'Bearer ' + Cookies.get('bs_token') }
        }).then((response) => {
            return response.data && response.data.data ? response.data.data.value : null;
        }).catch(() => {
            // Don't cache failures, so a later call can retry
            delete cache[cache_key];
            return null;
        });
    }

    return cache[cache_key];
}

export function isSettingEnabled(key) {
    return getCustomerSetting(key).then((value) => value === 'true' || value === '1');
}
